import React, { useState } from "react";

const CalendarEventCard = ({ event }) => {

    const [collapse, setCollapse] = useState(true)

    const showCollapse = (e) => {
        e.preventDefault()
        setCollapse(!collapse)
    }

    return (
        <div className="card mb-3" style={{ width: '900px', backgroundColor: event.bcolor }}>
            <div className="row g-0">
                <div className="col-md-4" style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)', minHeight: '200px' }}>
                    <img src={event.img} className="card-img h-100" style={{ objectFit: 'cover' }} alt="..." />
                </div>
                <div className="col-md-8 d-flex align-items-center">
                    <div className="card-body">
                        <h4 className="card-title">{event.name}</h4>
                        <h6 className="card-text">{new Date(event.date).toLocaleDateString()}</h6>
                        {event?.text1 && <p>{event.text1}</p>}
                        {event?.text2 && <p>{event.text2}</p>}
                        <div>
                            <div className="d-flex justify-content-center align-items-center mb-2">
                                <button type="button" className="btn btn-dark mx-1" disabled={event.link ? false : true}>
                                    <a href={event.link} style={{ textDecoration: 'None' }} className="text-white">Comprar entrada {event.linkB && 'A'}</a>
                                </button>

                                {event.linkB &&
                                    <button type="button" className="btn btn-dark mx-1">
                                        <a href={event.linkB} style={{ textDecoration: 'None' }} className="text-white">Comprar entrada B</a>
                                    </button>
                                }
                                {event.description &&
                                    <button className="btn btn-outline-dark mx-1" type="button" onClick={showCollapse}>
                                        Más Información
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div hidden={collapse} >
                <div className="card card-body">{event.description}</div>
            </div>
        </div>
    );
};

export default CalendarEventCard;